import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { maturityReviewAccessPermission } from '@internal/backstage-plugin-agentic-maturity-review-common';

import { rootRouteRef } from './routes';

/**
 * The permission check lives here rather than in the app's route tree: the new
 * frontend system does not support wrapping routes in `RequirePermission`, so
 * plugins gate their own pages.
 */
const maturityReviewPage = PageBlueprint.make({
  params: {
    path: '/maturity',
    routeRef: rootRouteRef,
    // These pages render their own Header; suppress the default plugin page header.
    noHeader: true,
    loader: () =>
      import('./components/MaturityReviewPage').then(m => (
        <RequirePermission permission={maturityReviewAccessPermission}>
          <m.MaturityReviewPage />
        </RequirePermission>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'agentic-maturity-review',
  routes: {
    root: rootRouteRef,
  },
  extensions: [maturityReviewPage],
});
